module.exports = __webpack_public_path__ + "img/login-v2.70340300.svg";